import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import "./index.scss";
import Select from "react-select";
import ticketService from "../../../services/TicketService";
import ticketMotivo from "../../../services/TicketMotivoService";
import helper from "../../../helpers/format";

import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import Anexos from "../../../components/Anexos";
import { GuService } from "../../../services/GuService";

const dadosIndicado = yup.object({
    assunto: yup
        .string()
        .min(2, "Assunto muito pequeno")
        .required("Campo obrigatório"),
    motivo: yup.string().required("Campo obrigatório"),
    descricao: yup.string().required("Campo obrigatório"),
});

export default function NovoChamado({ corTop, corButton, close }) {
    const [listaAnexos, setListaAnexos] = useState([]);

    const [motivosOptions, setMotivosOptions] = useState([]);
    const [motivosPorTipo, setMotivosPorTipo] = useState(false);
    const [motivosPorCategoria, setMotivosPorCategoria] = useState(false);
    const initialValues = {
        assunto: "",
        motivo: "",
        processo_opv: "",
        descricao: "",
        prazo_limite: "",
    };

    useEffect(() => {
        trackPromise(
            Promise.all([ticketMotivo.index()])
                .then((response) => {
                    let motivosOptions = [];
                    Object.values(response[0].data).forEach((item) => {
                        motivosOptions.push({
                            value: item.id_ticket_motivo,
                            label: item.nome,
                        });
                    });
                    setMotivosOptions(Object.values(response[0].data));
                })
                .catch((error) =>
                    Swal.fire({
                        titleText: "Ooops...",
                        text: "Ocorreu um erro ao buscar as dados: " + error,
                        icon: "error",
                    })
                )
        );
    }, []);

    function cadastraTicket(values) {
        let dados = {
            assunto: values.assunto,
            descricao: values.descricao,
            cpf: "",
            id_ticket_status: 1,
            id_ticket_motivo: values.motivo,
            tipo_cadastro: "U",
        };

        const formData = new FormData();
        for (let [chave, valor] of Object.entries(dados)) {
            formData.append(chave, valor);
        }

        if (listaAnexos?.length > 0) {
            listaAnexos.forEach((arquivo) => {
                if (arquivo.nome_arquivo_servidor) {
                    formData.append(
                        "dados_arquivos_pre_carregados[]",
                        JSON.stringify(arquivo)
                    );
                } else {
                    formData.append("dados_arquivo[]", arquivo);
                }
            });
        }
        trackPromise(
            ticketService
                .store(formData)
                .then((response) => {
                    const protocolo = response.data?.protocolo.split("-");
                    Swal.fire({
                        titleText: "Chamado aberto",
                        text: `Seu chamado foi aberto com sucesso! N° Protocolo ${
                            protocolo[0] + "-" + helper.zeroPad(protocolo[1], 5)
                        }`,
                        icon: "success",
                    });
                    close();
                })
                .catch((error) => {
                    Swal.fire({
                        titleText: "Ooops...",
                        text: "Ocorreu um erro ao salvar o chamado: " + error,
                        icon: "error",
                    });
                })
        );
    }

    return (
        <div className="containerNovoChamado">
            <Formik
                validationSchema={dadosIndicado}
                onSubmit={async (values) => {
                    cadastraTicket(values);
                }}
                initialValues={initialValues}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    errors,
                }) => (
                    <Form className="novoChamadoForm">
                        <Row>
                            <Col>
                                <div
                                    className="tituloNovoChamado"
                                    style={{ backgroundColor: corTop }}
                                >
                                    <h5>Novo Chamado</h5>
                                </div>
                            </Col>
                        </Row>
                        <label>
                            <div className="inputLabel">Assunto:</div>
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="assunto"
                            onChange={handleChange}
                        />
                        {errors.assunto && touched.assunto ? (
                            <div className="fildError">{errors.assunto}</div>
                        ) : null}
                        <Row>
                            <Col>
                                <label>
                                    <div className="inputLabel">Motivo</div>
                                </label>
                                <Select
                                    placeholder="Selecionar"
                                    value={values.value}
                                    onChange={(selectedOption) => {
                                        let eventTipo = [
                                            {
                                                target: {
                                                    name: "tipo",
                                                    value: selectedOption.tipo,
                                                },
                                            },
                                            {
                                                target: {
                                                    name: "motivo",
                                                    value: selectedOption.value,
                                                },
                                            },
                                            {
                                                target: {
                                                    name: "categoria",
                                                    value: selectedOption.categoria,
                                                },
                                            },
                                            {
                                                target: {
                                                    name: "prioridade",
                                                    value: selectedOption.prioridade,
                                                },
                                            },
                                        ];
                                        eventTipo.forEach((item) => {
                                            handleChange(item);
                                        });
                                    }}
                                    onBlur={() => {
                                        handleBlur({
                                            target: { name: "motivo" },
                                        });
                                    }}
                                    isSearchable={true}
                                    options={
                                        motivosPorCategoria
                                            ? motivosPorCategoria.map(
                                                  (item) => {
                                                      return {
                                                          tipo: item.id_ticket_tipo,
                                                          categoria:
                                                              item.id_ticket_categoria,
                                                          prioridade:
                                                              item.id_ticket_prioridade,
                                                          value: item.id_ticket_motivo,
                                                          label: item.nome,
                                                          sla: item.sla,
                                                          slo: item.slo,
                                                          sla_minutos:
                                                              item.sla_minutos,
                                                          slo_minutos:
                                                              item.slo_minutos,
                                                      };
                                                  }
                                              )
                                            : motivosPorTipo
                                            ? motivosPorTipo.map((item) => {
                                                  return {
                                                      tipo: item.id_ticket_tipo,
                                                      categoria:
                                                          item.id_ticket_categoria,
                                                      prioridade:
                                                          item.id_ticket_prioridade,
                                                      value: item.id_ticket_motivo,
                                                      label: item.nome,
                                                      sla: item.sla,
                                                      slo: item.slo,
                                                      sla_minutos:
                                                          item.sla_minutos,
                                                      slo_minutos:
                                                          item.slo_minutos,
                                                  };
                                              })
                                            : motivosOptions.map((item) => {
                                                  return {
                                                      tipo: item.id_ticket_tipo,
                                                      categoria:
                                                          item.id_ticket_categoria,
                                                      prioridade:
                                                          item.id_ticket_prioridade,
                                                      value: item.id_ticket_motivo,
                                                      label: item.nome,
                                                      sla: item.sla,
                                                      slo: item.slo,
                                                      sla_minutos:
                                                          item.sla_minutos,
                                                      slo_minutos:
                                                          item.slo_minutos,
                                                  };
                                              })
                                    }
                                    name="motivo"
                                    isLoading={false}
                                    loadingMessage={() => "Procurando"}
                                    noOptionsMessage={() =>
                                        "Nenhum resultado encontrado"
                                    }
                                />
                                {errors.motivo && touched.motivo ? (
                                    <div className="fildError">
                                        {errors.motivo}
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>
                                    <div className="inputLabel">Descrição</div>
                                </label>
                                <Field
                                    className="form-control"
                                    component="textarea"
                                    name="descricao"
                                    onChange={handleChange}
                                    validate={
                                        touched.descricao && !errors.descricao
                                    }
                                />
                                {errors.descricao && touched.descricao ? (
                                    <div className="fildError">
                                        {errors.descricao}
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ marginBottom: 10 }}>
                                <label>
                                    <div className="inputLabel"></div>
                                </label>
                                <div className="av-item select-file">
                                    <div className="documentacao-item-wrapper">
                                        <div className="form-group">
                                            <div>
                                                <h6>Arquivos:</h6>
                                            </div>
                                            <div className="upload-wrapper">
                                                <div
                                                    id="documento-0"
                                                    className="documento-wrapper"
                                                >
                                                    <div className="ajax-upload-dragdrop">
                                                        <span>
                                                            <Anexos
                                                                listaAnexos={
                                                                    listaAnexos
                                                                }
                                                                setListaAnexos={
                                                                    setListaAnexos
                                                                }
                                                                filesTypes={"*"}
                                                                formData={true}
                                                                habilitarPreVisualizacaoImagem={
                                                                    false
                                                                }
                                                            />
                                                        </span>
                                                    </div>
                                                    <div></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <button
                                    className="btNovoCadastro"
                                    type="submit"
                                    style={{ backgroundColor: corButton }}
                                >
                                    Abrir Chamado
                                </button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
